import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import {
  UserRoleAdmin,
  OrgRoleOrgAdmin,
  OrgRoleTerminalWorker,
} from '../../../shared/constants/user-role';
import { AuthenticationService } from '../services/authentication.service';
import { TokenService } from '../services/token.service';

export const terminalRoleGuard: CanActivateFn = async () => {
  const tokens = inject(TokenService);
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  const claims = tokens.decode();
  const isGlobalAdmin = claims?.user_role_id === UserRoleAdmin;
  const isOrgAdmin = claims?.org_role_id === OrgRoleOrgAdmin;
  const isTerminalWorker = claims?.org_role_id === OrgRoleTerminalWorker;
  if (isGlobalAdmin || isOrgAdmin || isTerminalWorker) return true;

  await auth.logout();
  return router.createUrlTree(['/login'], { queryParams: { error: 'no-terminal-access' } });
};
